<template>
  <div class="creatorsph">
    <div class="creatorsph-info">
      <div class="left-part">
        <img src="img/hp-default.svg" class="hp-logo" alt="" />
        <h1>Working with top creators in the Philippines</h1>
        <p>
          Filipino creators are earning directly from their fans with Helixpay's
          e-commerce tools for creators.
        </p>
        <a href="https://console.helixpay.ph/#/login" class="launch-signup">
          Sign-up for Free
        </a>
      </div>
      <div class="right-part">
        <div
          v-motion
          class="creators-info"
          :initial="{
            opacity: 0,
            y: 100,
          }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100,
              stiffness: 200,
              damping: 90,
              mass: 3,
            },
          }"
        >
          <div class="cards">
            <img src="img/nuggets-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                NISA NUGGETS
                <br />
                330,000 Youtube Subscribers
              </div>
            </div>
          </div>
          <div class="cards">
            <img src="img/koolpals-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                The KoolPals
                <br />
                35,000 Facebook Followers
              </div>
            </div>
          </div>
          <div class="cards">
            <img src="img/spart-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                SPART FARNACIO
                <br />
                620,000 Youtube Subscribers
              </div>
            </div>
          </div>
          <div class="cards">
            <img src="img/lauren-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                LAUREN YOUNG
                <br />
                2M Facebook Followers
              </div>
            </div>
          </div>
          <div class="cards">
            <img src="img/awkp-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                ANG WALANG KWENTANG PODCAST
                <br />
                Top 5 podcast in Philippines
              </div>
            </div>
          </div>
          <div class="cards">
            <img src="img/Coleen-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                Coleen Trinidad
                <br />
                1.4M Facebook Followers
              </div>
            </div>
          </div>
          <div class="cards">
            <img src="img/adamalejo-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                ADAM ALEJO
                <br />
                1M Youtube Subscribers
              </div>
            </div>
          </div>
          <div class="cards">
            <img src="img/maica-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                MAICA
                <br />
                Top Streamer on Kumu
              </div>
            </div>
          </div>
          <div class="cards">
            <img src="img/limpin-min.jpg" alt="Avatar" class="image" />
            <div class="show-text">
              <div class="text">
                KARL LIMPIN
                <br />
                House of Collab Celebrity
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.creatorsph {
  width: 100%;
}

.creatorsph-info {
  width: 71rem;
  margin: auto;
  padding-top: 3rem;
  padding-bottom: 5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  border-left: 2px solid white;
}

.creators-info {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
}

.hp-logo {
  width: 10rem;
  padding-left: 25px;
}

.left-part {
  display: grid;
}

.left-part h1 {
  line-height: 1.2;
  font-size: 4rem;
  font-weight: 800;
  margin-left: -2px;
  padding-left: 1.45rem;
  border-left: 2px solid #ff5f8f;
}

.left-part p {
  opacity: 0.5;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.5;
  padding-left: 1.45rem;
}

.launch-signup {
  width: 37%;
  border: 2px solid #ff5f8f;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  color: #ff5f8f;
  padding: 20px 30px;
  border-radius: 5px;
  margin-left: 1.45rem;
  margin-top: 2rem;
  font-weight: 600;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  transition: 0.2s ease-in-out;
}

.launch-signup:hover {
  color: white;
  background-color: #ff417a;
  border: 2px solid #ff417a;
  transform: translateY(-7px);
}

.cards {
  position: relative;
  width: 100%;
  background-color: black;
  border-radius: 20px;
}

.cards:nth-child(even) {
  box-shadow: 10px 10px #ff5f8f;
}

.cards img {
  width: 100%;
  border-radius: 20px;
}

.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 0.3s ease-out;
  backface-visibility: hidden;
}

.show-text {
  transition: 0.3s ease;
  opacity: 0;
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.cards:hover .image {
  opacity: 0.5;
}

.cards:hover .show-text {
  opacity: 1;
}

.text {
  background-color: rgb(48, 48, 48);
  color: white;
  line-height: 1.5;
  font-size: 0.6rem;
  font-weight: 400;
}

@media only screen and (max-width: 1400px) {
  .creatorsph-info {
    width: 60rem;
  }

  .launch-signup {
    width: 50%;
  }
}

@media only screen and (max-width: 1050px) {
  .creatorsph-info {
    width: 40rem;
    grid-template-columns: 1fr;
  }

  .launch-signup {
    width: 40%;
  }
}

@media only screen and (max-width: 650px) {
  .left-part h1 {
    font-size: 2rem;
    margin-left: 0;
    padding-left: 0;
    border-left: none;
  }

  .launch-signup {
    width: 60%;
    margin-left: 0;
  }

  .hp-logo {
    padding-left: 0;
  }

  .creatorsph-info {
    width: 90%;
    border-left: none;
  }

  .left-part p {
    padding-left: 0;
    font-size: 1rem;
  }
}
</style>
